import { render, staticRenderFns } from "./statisticsStudy.vue?vue&type=template&id=359a0682&scoped=true"
import script from "./statisticsStudy.vue?vue&type=script&lang=js"
export * from "./statisticsStudy.vue?vue&type=script&lang=js"
import style0 from "./statisticsStudy.vue?vue&type=style&index=0&id=359a0682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359a0682",
  null
  
)

export default component.exports